import { render, staticRenderFns } from "./TabPagoComplementario.vue?vue&type=template&id=0f701fd2"
import script from "./TabPagoComplementario.vue?vue&type=script&lang=js"
export * from "./TabPagoComplementario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f701fd2')) {
      api.createRecord('0f701fd2', component.options)
    } else {
      api.reload('0f701fd2', component.options)
    }
    module.hot.accept("./TabPagoComplementario.vue?vue&type=template&id=0f701fd2", function () {
      api.rerender('0f701fd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/tasks/validaciones/constitucionsociedades/TabPagoComplementario.vue"
export default component.exports